import { render, staticRenderFns } from "./AttachmentInfo.vue?vue&type=template&id=05d500bc&scoped=true&"
import script from "./AttachmentInfo.vue?vue&type=script&lang=js&"
export * from "./AttachmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentInfo.vue?vue&type=style&index=0&id=05d500bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d500bc",
  null
  
)

export default component.exports